<template>
  <survey-page :questions="questions"
               :question-types="questionTypes"
               :page-title="`היי ${this.householdName()},`"
               :pageSubTitle="'רצינו לדעת -'"
               :set-answer="setAnswer"
               :buttonTitle="'המשך'"
               :buttonAction="saveSurveyAnswers"/>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import _ from 'lodash';

import Segment from '../../../../../Segment';
import SurveyPage from '../../../../../base-components/survey/SurveyPage.vue';


export default {
  name: 'ActivationSurveyFirstPage',
  props: {
    questions: {
      type: Array,
      required: true,
    },
  },
  components: {
    SurveyPage,
  },
  computed: {
    ...mapState('activationSurvey', ['questionTypes']),
  },
  methods: {
    ...mapGetters('session', ['householdName']),
    ...mapActions('activationSurvey', ['setAnswer', 'completeFirstPage']),
    async saveSurveyAnswers() {
      const surveyAnswers = _.chain(this.questions).keyBy(question => question.name)
        .mapValues(question => question.answer).value();
      Segment.trackUserInteraction('ActivationSurveyFirstPageAnsweredClicked', surveyAnswers);
      await this.completeFirstPage();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/survey/activation-survey/ActivationSurveyFirstPage.vue